import { render, staticRenderFns } from "./QuoteIcon.vue?vue&type=template&id=0291d7da"
import script from "./QuoteIcon.vue?vue&type=script&lang=js"
export * from "./QuoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports